// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './assets/style.css'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents)

Vue.config.productionTip = false

Vue.mixin({
  methods:  {
    loader(promise,target){
      const container = document.querySelector(target);
      const loaderDiv = document.createElement('div');
      const spinner = document.createElement('span');
      for(let child of container.children){
        child.style.opacity = '0';
      }
      loaderDiv.classList.add('loading');
      loaderDiv.append(spinner);
      container.prepend(loaderDiv);
      const colors = [
        'rgb('+getComputedStyle(document.documentElement).getPropertyValue('--dgray')+')',
        'rgb('+getComputedStyle(document.documentElement).getPropertyValue('--yellow')+')',
        'rgb('+getComputedStyle(document.documentElement).getPropertyValue('--red')+')',
        'rgb(0,0,0)'

      ];
      const borders = [
        'borderTopRightRadius',
        'borderBottomRightRadius',
        'borderBottomLeftRadius',
        'borderTopLeftRadius'
      ]
      let counter = 0;
      setInterval(()=>{
        if(counter === 4) {
          counter = 0;
        }
        spinner.style.background = colors[Math.floor(Math.random()*3)];
        spinner.style.borderRadius = '50%';
        spinner.style[borders[counter]] = '0';
        counter++;
      },500)
      promise.then((res)=>{
        container.removeChild(container.childNodes[0]);
        for(let child of container.children){
          child.style.opacity = '1';
        }
        return res
      })

    },
    suprematism() {
      ga('send', {
        hitType: 'event',
        eventCategory: 'misc',
        eventAction: 'suprematismizer'
      });
      if(this.$route.name != 'home') {
        return;
      }
      function Mash() {
        var n = 0xefc8249d;

        var mash = function(data) {
          data = data.toString();
          for (var i = 0; i < data.length; i++) {
            n += data.charCodeAt(i);
            var h = 0.02519603282416938 * n;
            n = h >>> 0;
            h -= n;
            h *= n;
            n = h >>> 0;
            h -= n;
            n += h * 0x100000000; // 2^32
          }
          return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };

        mash.version = 'Mash 0.9';
        return mash;
      }
      function Alea() {
        return (function(args) {
          // Johannes Baagøe <baagoe@baagoe.com>, 2010
          var s0 = 0;
          var s1 = 0;
          var s2 = 0;
          var c = 1;

          if (args.length == 0) {
            args = [+new Date];
          }
          var mash = Mash();
          s0 = mash(' ');
          s1 = mash(' ');
          s2 = mash(' ');

          for (var i = 0; i < args.length; i++) {
            s0 -= mash(args[i]);
            if (s0 < 0) {
              s0 += 1;
            }
            s1 -= mash(args[i]);
            if (s1 < 0) {
              s1 += 1;
            }
            s2 -= mash(args[i]);
            if (s2 < 0) {
              s2 += 1;
            }
          }
          mash = null;

          var random = function() {
            var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
            s0 = s1;
            s1 = s2;
            return s2 = t - (c = t | 0);
          };
          random.uint32 = function() {
            return random() * 0x100000000; // 2^32
          };
          random.fract53 = function() {
            return random() +
              (random() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
          };
          random.version = 'Alea 0.9';
          random.args = args;
          return random;

        } (Array.prototype.slice.call(arguments)));
      };
      let alea = new Alea();

      function randomN(max,limit,neg,float) {
        let n;
        if(!float) {
          n = Math.floor(alea()*max);
        }
        else {
          n = Math.floor((alea()*max)*10) / 10;
        }

        if(limit && n < limit) { //tops
          n = limit;
        }

        if(neg) {
           if(alea() >= 0.5) { //boolean
            n=-n;
           }
        }
        return n;
      }
      function randomDeg() {
        return randomN(3,false,true)*45+'deg';
      };
      function randomRect(form,delay) {
        let w,h;
        if(form == 'square') {
          form = 'rect';
          w = randomN(500,100);
          h = w;
        }
        else {
          w = randomN(600,50);
          h = randomN(600,50);
        }
        let shape = document.createElementNS(svgns, form);
        shape.style.opacity = '0'
        shape.style.transition = 'all 200ms';
        shape.setAttributeNS(null, 'x', randomN(1600,200));
        shape.setAttributeNS(null, 'y', randomN(800));
        shape.setAttributeNS(null, 'height', h);
        shape.setAttributeNS(null, 'width', w);
        shape.style.transformOrigin = 'center center';
        shape.style.transform = 'translate('+randomN(100,false)+'%,'+randomN(100,false)+'%)';
        setTimeout(()=>{
          shape.style.transform = 'translate(0,0)';
          shape.style.opacity = '1';
          shape.style.transform = 'rotate('+randomDeg()+')';
        },delay);
        return shape;
      }
      function randomCirc(delay) {
        let shape = document.createElementNS(svgns, 'circle');
        shape.style.opacity = '0'
        shape.style.transition = 'all 300ms';
        shape.setAttributeNS(null, "cx", randomN(1400,200));
        shape.setAttributeNS(null, "cy", randomN(600,200));
        shape.setAttributeNS(null, "r",  randomN(400,100));
        shape.style.transform = 'translate('+randomN(100,false,1)+'%,'+randomN(100,false,1)+'%)';
        setTimeout(()=>{
          shape.style.transform = 'translate(0,0)';
          shape.style.opacity = '1'
        },delay);
        return shape;
      }
      function randomSemiCirc(delay) {
        let shape = document.createElementNS(svgns, 'path');
        shape.style.opacity = '0'
        shape.style.transformOrigin = 'center center';
        shape.style.transition = 'all 300ms';
        shape.setAttributeNS(null, "d", 'M'+randomN(600)+','+randomN(500)+' a1,1 0 0,0 '+randomN(600,100)+',0 z');
        shape.style.transform = 'rotate(0deg)';
        setTimeout(()=>{
          shape.style.transform = 'rotate('+randomDeg()+')';
          shape.style.opacity = '1'
        },delay);
        return shape;
      }
      const svgns = "http://www.w3.org/2000/svg";
      const svg = document.getElementById('suprematism');
      const shapesNo = randomN(12,6);
      const shapesTypes = ['circle','rect','path','square'];
      const colors =  [
        getComputedStyle(document.documentElement).getPropertyValue('--red'),
        getComputedStyle(document.documentElement).getPropertyValue('--yellow'),
        getComputedStyle(document.documentElement).getPropertyValue('--dgray'),
        '255,255,255',
        '0,0,0'
        //getComputedStyle(document.documentElement).getPropertyValue('--blue'),
      ];
      const shapesArr = [];
      svg.innerHTML = ''
      for(let i = 0; i<shapesNo;i++) {
        let form = shapesTypes[randomN(shapesTypes.length)];
        let shape;
        if(form == 'circle') {
          shape = randomCirc(100*i);
        }
        else if(form == 'path') {
          shape = randomSemiCirc(100*i);
        }
        else {
          shape = randomRect(form,100*i);
        }
        shape.setAttributeNS(null, 'stroke-width', randomN(20,10)+'px');
        shape.setAttributeNS(null, 'stroke', 'rgb('+getComputedStyle(document.documentElement).getPropertyValue('--lgray')+')');
        shape.setAttributeNS(null, 'fill', 'rgb('+colors[randomN(colors.length)]+')');
        svg.prepend(shape);
      }
      let ecos = document.getElementById('ecos').cloneNode(true);
      svg.appendChild(ecos);
      ecos.setAttributeNS(null, "fill", 'rgb('+colors[randomN(colors.length)]+')');
      ecos.setAttributeNS(null, 'x', randomN(1000,200));
      ecos.setAttributeNS(null, 'y', randomN(600));
      ecos.style.transform = 'translate('+randomN(80,10)+'% ,'+randomN(400)+'px) scale('+randomN(4,0.5,false,true)+') rotate('+randomDeg()+')';
    }
  },
  directives: {
    'linkout': {
     bind: function (el,binding,vnode) {
         el.addEventListener('click',(ev)=>{
           ev.preventDefault();
           window.open(el.href)
         });
       }
    },
    'ornament': {
        inserted: function(el) {
          el.innerHTML = '<span class="ornament">\
            <hr />\
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\
               viewBox="0 0 100 100" height="20px" width="30px" preserveAspectRatio="xMinYMax meet">\
            <polygon points="142.034,42.195 139.614,39.776 139.417,39.974 139.417,39.973 94.786,84.604 97.205,87.023 141.637,42.591\
              141.637,42.591 142.034,42.195 "/>\
            <polygon points="124.733,25.29 123.524,24.081 124.733,25.29 124.93,25.092 122.512,22.673 122.313,22.871 122.313,22.871\
              77.683,67.501 80.101,69.92 124.733,25.29 "/>\
            <polygon points="118.833,19.787 119.03,19.588 116.612,17.169 71.982,61.799 74.4,64.219 118.833,19.786 118.833,19.787 "/>\
            <polygon points="113.329,13.887 110.911,11.468 66.332,56.047 63.049,52.765 107.627,8.186 105.209,5.767 60.63,50.346\
              57.315,47.031 101.926,2.419 99.507,0 72.028,27.479 44.548,0 0,44.548 44.548,89.096 71.964,61.68 68.75,58.466 "/>\
            <polygon points="135.936,36.89 136.331,36.494 133.913,34.075 89.084,78.903 91.503,81.322 135.936,36.889 135.936,36.89 "/>\
            <polygon points="130.432,30.991 130.432,30.991 130.631,30.792 128.211,28.374 128.014,28.571 128.014,28.57 83.383,73.202\
              85.802,75.621 130.432,30.991 "/>\
            </svg>\
            <hr />\
          </span>';
        }
      }
    },
    filters: {
      shortDate(str) {
        return str.substring(0, 10).split('-').reverse().join('/');
      },
      formatImg(str){
        if(str) {
          str = str.split('src=')[1].split(' ')[0].replace('\'','').replace('"','').trim();
          return 'background-image: url('+str.replace('\'','').replace('"','').trim()+')'; //?
        }
      }
    }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js